import requests from '../util';

const { request } = requests;

const fetchMyGeneratedImages = (
  pageNum,
  pageSize,
  searchText,
  timeZone,
  type
) => {
  return request({
    url: '/api/v1/task/getTasksGroupedByDate',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      timeZone,
      taskType: type,
      //   searchText,
    },
  });
};

const fetchMyGeneratedImagesByDate = (
  pageNum,
  pageSize,
  searchText,
  timeZone,
  type,
  date
) => {
  return request({
    url: '/api/v1/task/getTasksGroupedByDate',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      timeZone,
      taskType: type,
      requestCreatedAt: date,
      //   searchText,
    },
  });
};
const downloadImageByDate = (payload) => {
  return request({
    url: '/api/v1/task/zipBodySwapTask',
    method: 'get',
    params: {
      timeZone: payload.userTimeZone,
      requestCreatedAt: payload.date,
    },
  });
};
const downloadImageManualEditingByDate = (payload) => {
  return request({
    url: '/api/v1/task/zipManualEditingTask',
    method: 'get',
    params: {
      timeZone: payload.userTimeZone,
      requestCreatedAt: payload.date,
    },
  });
};
const myImagesApi = {
  fetchMyGeneratedImages,
  fetchMyGeneratedImagesByDate,
  downloadImageByDate,
  downloadImageManualEditingByDate,
};

export default myImagesApi;
